// client/src/components/landing/RecentProjectsSection.js
// 지금 모집 중인 프로젝트 — v6 B안 리디자인 (공고 offer 카드)
// 공개 API(/api/public/projects/recent) 조회·카드 클릭 시 로그인 모달 로직은 기존 그대로.
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import LoginModal from '../LoginModal';

function RecentProjectsSection() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await fetch('/api/public/projects/recent');
        if (!res.ok) throw new Error('Failed to fetch');
        const data = await res.json();
        setProjects(data.items || []);
      } catch (error) {
        console.error('Failed to load projects:', error);
        setProjects([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  // 서비스 타입 표시 텍스트
  const getServiceTypeText = (serviceType) => {
    switch (serviceType) {
      case 'delivery': return '제품 제공';
      case 'purchase': return '제품 미제공';
      case 'visit': return '장소 광고';
      case 'place': return '장소 광고';
      case 'custom': return '광고주 자율방식';
      case 'free': return '광고주 자율방식';
      default: return serviceType;
    }
  };

  const PLATFORM_LABEL = { instagram: '인스타그램', youtube: '유튜브', blog: '블로그', tiktok: '틱톡' };

  // 마감일까지 남은 일수 계산
  const getDeadlineDays = (recruitEnd) => {
    if (!recruitEnd) return null;
    const now = new Date();
    const endDate = new Date(recruitEnd);
    now.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    const diffDays = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));
    if (diffDays < 0) return null; // 마감됨
    return diffDays;
  };

  const handleCardClick = () => {
    setShowLoginModal(true);
  };

  const handleCloseLoginModal = () => {
    setShowLoginModal(false);
  };

  const sectionHead = (
    <div className="lnd-sec__head">
      <span className="eyebrow">LIVE</span>
      <h2>지금 모집 중인 프로젝트</h2>
      <p>인플루언서를 기다리는 리뷰 프로젝트들이에요 — 지원하고 협찬과 보상을 받아보세요.</p>
    </div>
  );

  // 로딩 중
  if (loading) {
    return (
      <section className="lnd-sec lnd-wrap" style={{ paddingTop: 16 }}>
        {sectionHead}
        <div className="lnd-loading">프로젝트를 불러오는 중...</div>
      </section>
    );
  }

  // Empty State
  if (projects.length === 0) {
    return (
      <section className="lnd-sec lnd-wrap" style={{ paddingTop: 16 }}>
        {sectionHead}
        <div className="offers-empty">
          <b>새 광고 프로젝트를 준비 중이에요</b>
          <p>
            곧 이곳에 모집 공고가 올라옵니다.<br />
            지금 가입하고 승인을 받아 두시면, 모집이 시작되는 순간 바로 지원할 수 있어요.
          </p>
          <Link to="/influencer/register" className="lnd-btn lnd-btn--mint">
            인플루언서 가입하기
          </Link>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="lnd-sec lnd-wrap" style={{ paddingTop: 16 }}>
        {sectionHead}

        <div className="offers">
          {projects.map((project) => {
            const days = getDeadlineDays(project.recruitEnd);
            const platforms = (project.platforms || []).map((p) => PLATFORM_LABEL[p?.toLowerCase()] || p).join(' · ');
            const subParts = [
              getServiceTypeText(project.serviceType),
              platforms || null,
              `모집 ${project.headcount}명`,
            ].filter(Boolean);
            return (
              <button key={project.id} type="button" className="offer" onClick={handleCardClick}>
                <div className="offer__head">
                  <span className="offer__logo" aria-hidden="true">
                    {project.cover
                      ? <img src={project.cover} alt="" loading="lazy" />
                      : (project.productName || '프').charAt(0)}
                  </span>
                  <span className="offer__meta">
                    <span className="offer__t">{project.productName || '광고 프로젝트'}</span>
                    <span className="offer__s">{subParts.join(' · ')}</span>
                  </span>
                  {days != null && (
                    <span className={`lnd-badge ${days <= 2 ? 'lnd-badge--red' : 'lnd-badge--mint'}`}>
                      {days === 0 ? '오늘 마감' : `D-${days}`}
                    </span>
                  )}
                </div>
                <div className="offer__reward num">
                  <div>
                    <b className="is-mint">{Number(project.rewardPointPerCreator || 0).toLocaleString()}P</b>
                    <span>기본 보상</span>
                  </div>
                  <div>
                    {project.perPurchaseReward?.use
                      ? <><b className="is-violet">+{Number(project.perPurchaseReward.rewardPerBuyer || 0).toLocaleString()}P</b><span>구매 1명당</span></>
                      : <><b>—</b><span>CPS 없음</span></>}
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        <div className="offers-note">
          <button type="button" className="lnd-btn lnd-btn--ghost" onClick={handleCardClick}>
            모집 중인 프로젝트 모두 보기
          </button>
        </div>
      </section>

      {/* 로그인 모달 */}
      {showLoginModal && (
        <LoginModal onClose={handleCloseLoginModal} />
      )}
    </>
  );
}

export default RecentProjectsSection;
